module.exports = __webpack_public_path__ + "img/28.dbafcbe6.jpg";